import * as React from 'react';
import { SVGProps } from 'react';

const IconAxesRotateSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m1 11 4 4 4-4H6a5 5 0 0 1 5-5v3l4-4-4-4v3a7 7 0 0 0-7 7H1ZM4 3V1h2v2a3 3 0 0 1-3 3H1V4h2a1 1 0 0 0 1-1Z" />
  </svg>
);
export default IconAxesRotateSizeS;
